module.exports = __webpack_public_path__ + "img/icon_1.769dc92a.png";